import { render, staticRenderFns } from "./nav-menu.component.vue?vue&type=template&id=0248b9e9&"
import script from "./nav-menu.component.vue?vue&type=script&lang=js&"
export * from "./nav-menu.component.vue?vue&type=script&lang=js&"
import style0 from "./nav-menu.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports